import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67b934a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "media-section-wrapper" }
const _hoisted_2 = { class: "media-section-title" }
const _hoisted_3 = { class: "media-section-desc" }
const _hoisted_4 = { class: "media-list-wrapper row" }
const _hoisted_5 = {
  key: 0,
  class: "show-more-wrapper"
}
const _hoisted_6 = ["src"]

import { ref, computed } from 'vue';
  import MediaItem, { Media } from './media-item.vue';
  import { useI18n } from 'vue-i18n';

  export interface MediaType extends Media {
    id: number;
    content_type: string;
  }

  export interface IProps {
    name?: string;
    desc?: string;
    files: MediaType[];
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    name: { default: '' },
    desc: { default: '' },
    files: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { name: string, desc: string, files: MediaType[] }

  const { t } = useI18n();
  const minCount = 4;
  const showMore = ref(false);
  const mediaList = computed<MediaType[]>(() => {
    return showMore.value ? props.files : props.files.slice(0, minCount);
  });

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(props.name), 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(props.desc), 1),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mediaList), (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id,
          class: "col-md-6 col-12"
        }, [
          _createVNode(MediaItem, {
            filename: item.filename,
            url: item.url,
            "content-type": item.content_type
          }, null, 8, ["filename", "url", "content-type"])
        ]))
      }), 128))
    ]),
    (props.files.length > minCount)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "show-more",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showMore.value = !showMore.value))
          }, [
            _createElementVNode("img", {
              src: showMore.value ? require('@/assets/icon/expand-on.png') : require('@/assets/icon/expand-off.png'),
              class: "icon"
            }, null, 8, _hoisted_6),
            _createElementVNode("span", null, _toDisplayString(showMore.value ? _unref(t)('Show less') : _unref(t)('Show more')), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})